import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import store from "../src/store/store.js";
import { I18nextProvider } from "react-i18next";
import i18n from "../src/locales/i18n";
import { Provider } from "react-redux";
import "swiper/css";
import "swiper/css/effect-fade"; // Для fade-эффекта

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
        <Provider store={store}>
            <I18nextProvider i18n={i18n}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </I18nextProvider>
        </Provider>
);
